module.exports = __webpack_public_path__ + "img/orange-booth-table-4.6185d173.png";